import React, { useState } from 'react';
import { FaLightbulb, FaUsers, FaChartLine, FaExclamationTriangle, FaDollarSign, FaClock, FaChevronDown, FaChevronUp } from 'react-icons/fa';

const StrategyCard = ({ strategy, selected = false, onSelect, position = 1, expanded = false, onToggle }) => {
    const [isExpanded, setIsExpanded] = useState(false);

    console.log('StrategyCard received strategy:', strategy);
    console.log('Strategy channels:', strategy?.channels);
    console.log('Channels type:', typeof strategy?.channels);
    console.log('Is channels array?', Array.isArray(strategy?.channels));

    const handleToggle = () => {
        setIsExpanded(!isExpanded);
        if (onToggle) onToggle();
    };

    const getCostColor = (cost) => {
        switch (cost) {
            case 'low':
                return 'bg-green-100 text-green-800';
            case 'medium':
                return 'bg-yellow-100 text-yellow-800';
            case 'high':
                return 'bg-red-100 text-red-800';
            default:
                return 'bg-gray-100 text-gray-800';
        }
    };

    const getCostLabel = (cost) => {
        switch (cost) {
            case 'low':
                return 'Bajo';
            case 'medium':
                return 'Medio';
            case 'high':
                return 'Alto';
            default:
                return cost;
        }
    };

    return (
        <div className={`
      relative bg-white rounded-lg shadow-lg border-2 transition-all duration-300
      ${selected
                ? 'border-purple-500 bg-purple-50 shadow-purple-200'
                : 'border-gray-200 hover:border-gray-300 hover:shadow-xl'
            }
    `}>
            {/* Position Badge */}
            <div className="absolute top-4 right-4">
                <div className="w-8 h-8 bg-purple-500 text-white rounded-full flex items-center justify-center text-sm font-bold">
                    {position}
                </div>
            </div>

            {/* Header */}
            <div className="p-6 pb-4">
                <div className="flex items-start mb-4">
                    <div className="w-12 h-12 bg-purple-100 rounded-full flex items-center justify-center mr-4 flex-shrink-0">
                        <FaLightbulb className="text-purple-500 text-xl" />
                    </div>
                    <div className="flex-1">
                        <h3 className="text-lg font-bold text-gray-900 mb-2 leading-tight">
                            {strategy.title}
                        </h3>
                        <p className="text-gray-600 text-sm leading-relaxed">
                            {strategy.description}
                        </p>
                    </div>
                </div>

                {/* Approach */}
                <div className="bg-blue-50 rounded-lg p-4 mb-4">
                    <h4 className="text-sm font-medium text-gray-900 mb-2">Enfoque Metodológico</h4>
                    <p className="text-sm text-gray-700">{strategy.approach}</p>
                </div>

                {/* Target Audience */}
                <div className="flex items-start mb-4">
                    <FaUsers className="text-blue-500 mr-3 mt-1 flex-shrink-0" />
                    <div>
                        <div className="text-sm font-medium text-gray-900 mb-1">Audiencia Objetivo</div>
                        <div className="text-sm text-gray-600">{strategy.targetAudience}</div>
                    </div>
                </div>

                {/* Channels */}
                <div className="mb-4">
                    <h4 className="text-sm font-medium text-gray-900 mb-2">Canales de Comunicación</h4>
                    <div className="flex flex-wrap gap-2">
                        {strategy.channels && Array.isArray(strategy.channels) ? (
                            strategy.channels.map((channel, index) => (
                                <span key={index} className="px-3 py-1 bg-gray-100 text-gray-700 rounded-full text-xs">
                                    {channel}
                                </span>
                            ))
                        ) : strategy.channels ? (
                            <span className="px-3 py-1 bg-gray-100 text-gray-700 rounded-full text-xs">
                                {strategy.channels}
                            </span>
                        ) : (
                            <span className="px-3 py-1 bg-gray-100 text-gray-700 rounded-full text-xs">
                                No especificado
                            </span>
                        )}
                    </div>
                </div>

                {/* Expected Results */}
                <div className="bg-green-50 rounded-lg p-4 mb-4">
                    <div className="flex items-center mb-2">
                        <FaChartLine className="text-green-500 mr-2" />
                        <span className="text-sm font-medium text-gray-900">Resultados Esperados</span>
                    </div>
                    <p className="text-sm text-gray-700">{strategy.expectedResults}</p>
                </div>

                {/* Cost and Time */}
                <div className="grid grid-cols-2 gap-4 mb-4">
                    <div className="flex items-center">
                        <FaDollarSign className="text-green-500 mr-2" />
                        <div>
                            <div className="text-xs text-gray-500">Costo</div>
                            <span className={`px-2 py-1 rounded-full text-xs font-medium ${getCostColor(strategy.cost)}`}>
                                {getCostLabel(strategy.cost)}
                            </span>
                        </div>
                    </div>
                    <div className="flex items-center">
                        <FaClock className="text-blue-500 mr-2" />
                        <div>
                            <div className="text-xs text-gray-500">Tiempo</div>
                            <div className="text-sm font-medium text-gray-900">{strategy.implementationTime}</div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Expandable Content */}
            <div className="border-t border-gray-200">
                <div
                    className="p-4 flex items-center justify-between cursor-pointer hover:bg-gray-50"
                    onClick={handleToggle}
                >
                    <span className="text-sm font-medium text-gray-700">Ver Detalles Completos</span>
                    {isExpanded ? <FaChevronUp /> : <FaChevronDown />}
                </div>

                {isExpanded && (
                    <div className="px-4 pb-4 space-y-4">
                        {/* Risks */}
                        {strategy.risks && (
                            <div className="bg-red-50 rounded-lg p-4">
                                <div className="flex items-center mb-2">
                                    <FaExclamationTriangle className="text-red-500 mr-2" />
                                    <h4 className="text-sm font-medium text-gray-900">Riesgos y Mitigaciones</h4>
                                </div>
                                <p className="text-sm text-gray-700">{strategy.risks}</p>
                            </div>
                        )}
                    </div>
                )}
            </div>

            {/* Selection Button */}
            <div className="p-4 pt-0">
                <button
                    onClick={() => onSelect(strategy.id)}
                    className={`
            w-full py-3 px-4 rounded-lg font-medium transition-all duration-200
            ${selected
                            ? 'bg-purple-600 text-white hover:bg-purple-700'
                            : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                        }
          `}
                >
                    {selected ? '✓ Estrategia Seleccionada' : 'Seleccionar Estrategia'}
                </button>
            </div>
        </div>
    );
};

export default StrategyCard; 